<app-navbar></app-navbar>

<div class="min-h-screen bg-gradient-to-br from-slate-50 via-purple-50/20 to-indigo-50/30 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 ml-auto lg:w-[75%] xl:w-[80%] 2xl:w-[85%]">

  <!-- Badge BETA -->
  <div *ngIf="isBeta" class="fixed top-7 -left-5 z-50 lg:top-10 lg:-left-5">
    <div class="bg-gradient-to-r from-orange-500 to-red-500 text-white px-3 py-1 rounded-full shadow-lg transform -rotate-45 animate-pulse">
      <span class="font-mono text-xs font-bold tracking-wider">BETA {{version}}</span>
    </div>
  </div>
  
  <!-- Banner de advertencia - Solo en beta -->
  <div *ngIf="isBeta" class="mx-4 lg:mx-8 mt-4">
    <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-2xl p-4">
      <div class="flex items-center space-x-3">
        <span class="text-2xl">🧪</span>
        <p class="font-mono text-blue-800 dark:text-blue-200 font-medium">
          Función en desarrollo - Úsala con precaución
        </p>
      </div>
    </div>
  </div>


  <!-- Profile Content -->
  <div class="px-4 lg:px-8 py-6 lg:py-8">
    <div class="max-w-4xl mx-auto">
      
      <!-- Header -->
      <div class="text-center mb-8">
        <h1 class="font-mono text-3xl lg:text-4xl font-bold text-gray-800 dark:text-gray-200 mb-3">
          Mi Perfil
        </h1>
        <p class="font-mono text-gray-600 dark:text-gray-400 text-lg">
          Resumen de tu actividad en ReliefApp
        </p>
      </div>

      <!-- Stats Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <!-- Total Reliefs -->
        <div class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-sm rounded-2xl border border-purple-100 dark:border-slate-700 shadow-lg hover:shadow-xl transition-all duration-300 p-6">
          <div class="flex items-center space-x-4">
            <div class="w-16 h-16 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-2xl flex items-center justify-center">
              <svg class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div>
              <span class="text-3xl font-bold font-mono text-purple-600 dark:text-purple-400">{{ totalReliefs }}</span>
              <p class="font-mono text-gray-600 dark:text-gray-400 text-sm">Total de Pensamientos</p>
            </div>
          </div>
        </div>

        <!-- Writing Streak -->
        <div class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-sm rounded-2xl border border-purple-100 dark:border-slate-700 shadow-lg hover:shadow-xl transition-all duration-300 p-6">
          <div class="flex items-center space-x-4">
            <div class="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl flex items-center justify-center">
              <span class="text-2xl" [attr.title]="wroteToday ? 'Racha activa' : 'Sin racha activa'">
                {{ wroteToday ? '🔥' : '🪵' }}
              </span>
            </div>
            <div>
              <span class="text-3xl font-bold font-mono text-orange-500 dark:text-orange-400">{{ writingStreak }}</span>
              <p class="font-mono text-gray-600 dark:text-gray-400 text-sm">Días escribiendo</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Frequent Feeling Section -->
      <div class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-sm rounded-2xl border border-purple-100 dark:border-slate-700 shadow-lg p-6 mb-8">
        <div class="flex items-center space-x-3 mb-6">
          <div class="w-10 h-10 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center">
            <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
            </svg>
          </div>
          <h2 class="font-mono text-xl font-bold text-gray-800 dark:text-gray-200">
            Análisis del último mes
          </h2>
        </div>
        
        <div class="mb-4">
          <p class="font-mono text-gray-700 dark:text-gray-300 mb-2">
            Sentimiento más frecuente:
          </p>
          <div class="inline-flex items-center bg-gradient-to-r from-purple-100 to-indigo-100 dark:from-purple-900/30 dark:to-indigo-900/30 px-4 py-2 rounded-xl border border-purple-200 dark:border-purple-800">
            <span class="font-mono font-bold text-purple-700 dark:text-purple-300 capitalize">{{ recurrentFeeling || 'Sin datos' }}</span>
          </div>
        </div>

        <!-- Feelings Chart -->
        <div *ngIf="feelingCount && (feelingCount | keyvalue).length > 0" class="mt-6">
          <h3 class="font-mono font-semibold text-gray-700 dark:text-gray-300 mb-4">Distribución de sentimientos:</h3>
          <div class="space-y-3">
            <div *ngFor="let feeling of feelingCount | keyvalue" 
                 class="flex items-center justify-between bg-gray-50/80 dark:bg-slate-700/80 rounded-xl px-4 py-3 border border-gray-200 dark:border-slate-600">
              <span class="capitalize font-mono text-gray-700 dark:text-gray-300 font-medium">{{ feeling.key }}</span>
              <div class="flex items-center space-x-3">
                <div class="w-24 bg-gray-200 dark:bg-slate-600 rounded-full h-2">
                  <div class="bg-gradient-to-r from-purple-500 to-indigo-600 h-2 rounded-full transition-all duration-500" 
                       [style.width.%]="(feeling.value / totalReliefs) * 100"></div>
                </div>
                <span class="font-mono text-sm font-bold text-purple-600 dark:text-purple-400 min-w-[2rem] text-right">{{ feeling.value }}</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!feelingCount || (feelingCount | keyvalue).length === 0" class="text-center py-8">
          <div class="w-16 h-16 bg-gray-100 dark:bg-slate-700 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
            </svg>
          </div>
          <p class="font-mono text-gray-500 dark:text-gray-400">No hay datos suficientes del último mes</p>
        </div>
      </div>

    </div>
  </div>
</div>
